import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentRU = props => {
    return <Aux>
        <SectionHeading priority={1} text='Зачем выбрать "Юра"?' />
        <ul>
            <li>Малоэтажное здание, которое гармонирует с окружающим ландшафтом, соответствует всем требованиям высших стандартов строительства и эксклюзивности.</li>
            <li>Просторные апартаменты с отличным видом площадью от 74 до 300 кв.м.</li>
            <li>Исключительно удобное местоположение для проезда - рядом бул."Васил Левски" и бул."Княз Борис I", городской транспорт во всех направлениях.</li>
            <li>Рядом находятся элитные образовательные учреждения</li>
            <li>Здание окружено двумя парками</li>
            <li>Лучшее местоположение – престижный микрорайон</li>
            <li>Здание соответствует всем требованиям энергоэффективности, класса А</li>
            <li>Отличная звукоизоляция</li>
            <li>Решена проблема с парковкой.</li>
            <li>Есть проводки для интернета и кабельного телевидения.</li>
            <li>Подготовка к установлению кондиционеров.</li>
            <li>Подготовка к газификации.</li>
            <li>Небольшое количество апартаментов в одном подъезде – небольшое количество соседей позволяет комфортно себя чувствовать в своем жилище.</li>
            <li>Здание впечатляет внешним видом. Здание спроектировано в соответствии с новейшими тенденциями в архитектуре и с современными требованиями к конструкциям.</li>
            <li>Соблюдаются высший стандарт качества, контроль и гарантии завершенности.</li>
        </ul>
    </Aux>
}

export default ContentRU



// WEBPACK FOOTER //
// ./src/routes/WhyJura/components/ContentRU.js